import { render, staticRenderFns } from "./BaseSubComponent.vue?vue&type=template&id=14321ad3&"
import script from "./BaseSubComponent.vue?vue&type=script&lang=ts&"
export * from "./BaseSubComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports